import {
  USER_ITEM_LIST_DATA_RAW,
  USER_ITEM_LIST_DATA,
} from '../../data/user/constant';

export const MODULE_NAME = 'USER_LIST_MODULE_NAME';

export const ACTION_TYPE = {
  REQUEST_PENDING: `${MODULE_NAME}.REQUEST_PENDING`,
};

export const API = {
  TYPE: 'GET',
  URL: `/user/admin/user`,
};

export interface ACTION_RESPONSE_INTER extends USER_ITEM_LIST_DATA_RAW {}

export interface DATA extends USER_ITEM_LIST_DATA {}

export interface ACTION_ERROR_INTER {
  error: string;
  message: string;
  messages: string[];
  statusCode: string;
}
